import ClientsBaseController from 'webapp/controllers/clients/base';

export default class ClientsPerformanceController extends ClientsBaseController {
	override trackingOrigin = 'client_performance';
}
